import { Button } from "@chakra-ui/react";
import { DownloadIcon } from "../../../assets/icons/DownloadIcon";
import { useParams } from "react-router-dom";
import { useState } from "react";
import Axios from "../../../services/axios";

export function DownloadDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  async function handleDownload() {
    try {
      setIsLoading(true);
      const response = await Axios({
        url: `/admin/community/detail/${id}/download`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { 
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `community-detail-${id}.xlsx`; // You can customize the filename
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Button isDisabled={isLoading} isLoading={isLoading} leftIcon={<DownloadIcon />} fontWeight="400" backgroundColor="#fff" border="1px solid #E2E8F0" color="#1A202C" onClick={handleDownload}>
      Download
    </Button>
  );
}